function setupMap() {
    // Map venir à la clinique
    var map = jQuery('#map');
    if (!map) {
        return;
    }

    var lat = map.data('lat');
    var lng = map.data('lng');
    var icon = map.data('icon');

    map = L.map('map', { zoomControl: false }).setView([lat, lng], 6);
    var show = false;

    var poi = L.icon({
        iconUrl: icon,
        iconSize: [26, 34], // size of the icon
        iconAnchor: [13, 34], // point of the icon which will correspond to marker's location
    });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png', {
        maxZoom: 20,
        minZoom: 5,
        attribution: ''
    }).addTo(map);

    L.marker([lat, lng], { icon: poi }).addTo(map)
        .on('click', function() {
            if (!show) {
                jQuery('.map-container').addClass('show');
                show = true;
            } else {
                jQuery('.map-container').removeClass('show');
                show = false;

            }
        })
}

function slickJumbo() {
    jQuery('.jumbotron__slides.slick').slick({
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,

    });
}

jQuery(function() {
    // Slick Jumbotron
    jQuery(window).resize(Foundation.util.throttle(function() {
        if (Foundation.MediaQuery.atLeast('large')) {
            slickJumbo();
        }
    }, 500));
    jQuery(window).trigger('resize');

    //
    if (!Foundation.MediaQuery.atLeast('large')) {
        jQuery('.footer .first-menu').on("click", function() {
            jQuery(this).find('ul').slideToggle();
        });
        jQuery('.footer .second-menu').on("click", function() {
            jQuery(this).find('ul').slideToggle();
        });
    }

    // Loading pour les requêtes ajax
    $(document)
        .ajaxStart(function() {
            jQuery('body').addClass('loading');
        })
        .ajaxComplete(function() {
            jQuery('body').removeClass('loading');
        });

    // Retour en haut de page
    jQuery('.bt_top, .top').on('click', function(event) {
        jQuery('body, html').stop().animate({ scrollTop: 0 }, 800);
        event.preventDefault();
    });

    // Map leaflet
    setupMap();

    // Mobile footer menu
    jQuery('.footer-menu__open-menu').click(function() {
        jQuery('.footer-menu__content').toggleClass('show');
        jQuery('.footer-menu__open-menu').toggleClass('opened');
        jQuery(".footer-menu__menu .is-drilldown").removeAttr("style");
        jQuery('.js-drilldown-back a').html("Retour");
    });
    jQuery('.vertical.lateral__menu').attr('data-parent-link', true);

})